// 项目公共逻辑和方法
const app = {}
app.switchUA = function(page){
  if((navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i))){
    if(page == 'pc'){
      location.replace("/m/index.html");
    }
  }else{
    if(page == 'm'){
      location.replace("/pc/index.html");
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/lib/app/js/app.js